export const version = '3.1.5'
export const name = 'js-libp2p'
